import { useLocalization } from '../../../../../../app/_providers/LocalizationProvider.client'
import { useOrganization } from '../../../../../../app/_providers/OrganizationProvider.client'

/**
 * Determines if a user is eligible for Affirm messaging in Minicart.
 *
 * An eligible user is:
 * - in the US region, with a language of `en` or `es`
 * - *not* shopping in a Team Store or Portal
 */
export function useIsAffirmEligible() {
  const { isUSRegion, languageGroup } = useLocalization()
  const { b2bStorefrontCollection } = useOrganization()

  const isValidLocale = isUSRegion && (languageGroup === 'en' || languageGroup === 'es')
  const isD2C = !b2bStorefrontCollection

  return isValidLocale && isD2C
}
